namespace $ {
	
	// export class $shm_hitalama_domain_config extends $mol_object2 {
	// }

	export class $shm_hitalama_domain extends $giper_baza_entity.with({

		/** @deprecated Use profile home/key auth instead. */
		Profiles: $giper_baza_atom_link.to( ()=> $shm_hitalama_profile_dict ),

		Projects: $giper_baza_list_link.to( ()=> $shm_hitalama_project ),
		Doc_maps: $giper_baza_list_link.to( ()=> $shm_hitalama_map ),
		Task_maps: $giper_baza_list_link.to( ()=> $shm_hitalama_map ),

	}){

		@ $mol_mem
		static domain_link( next?: string ){
			$mol_wire_solid()
			if( next !== undefined ) return this.$.$mol_state_local.value( this+'.domain_link', next ) || 'DUzQmtUH_KQ0INJej'

			const config = this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_settings.tauri_config(),
				()=> null,
				()=> null,
			)
			if( config?.selfhosted_tauri && config.domain_link ) {
				return this.$.$mol_state_local.value( this+'.domain_link', config.domain_link ) || config.domain_link
			}

			return this.$.$mol_state_local.value( this+'.domain_link', next ) || 'DUzQmtUH_KQ0INJej'
		}

		@ $mol_mem
		static instance() {
			$mol_wire_solid()
			const ref = new $giper_baza_link( this.domain_link() )
			const domain = this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_domain )
			return domain
		}
		
		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		profiles() {
			$mol_wire_solid()
			return this.Profiles()?.remote()!
		}

		/** @deprecated Use profile home/key auth instead. */
		@ $mol_action
		profiles_ensure() {
			const profiles = this.profiles()
			if( profiles && ( profiles.can_change() || !this.can_change() ) ) return profiles

			const next = this.can_change()
				? this.land().area_make().Data( this.$.$shm_hitalama_profile_dict )
				: this.$.$giper_baza_glob.land_grab( [[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ]] ).Data( this.$.$shm_hitalama_profile_dict )
			this.Profiles(null)?.remote( next )
			return next
		}

		@ $mol_mem
		projects() {
			$mol_wire_solid()
			return this.Projects(null)!
		}
		
		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		static pull_pass_keys() {
			const profiles = this.instance().profiles()!
			profiles?.keys().forEach( k => {
				try {
					profiles.key(k)?.remote()?.Pass_key()?.val() 
				} catch (error) {
					console.log( error )
				}
			} )
		}

		/** @deprecated Use profile home/key auth instead. */
		@ $mol_mem
		static pull_pass_keys_periodic() {
			return new $mol_wire_atom( '', ()=> {
				$mol_state_time.now( 1000 )
				this.pull_pass_keys()
			} ).plan()
		}
		
	}
}
